import type { ComponentPublicInstance } from "vue"
import { Timeline } from "./timeline"

export function startErrorTracking () {
  window.addEventListener('error', trackError)
  window.addEventListener('unhandledrejection', trackPromiseRejected)
}

export function stopErrorTracking () {
  window.removeEventListener('error', trackError)
  window.removeEventListener('unhandledrejection', trackPromiseRejected)
}

function getStack (error: unknown) {
  if (error && typeof error === 'object' && 'stack' in error) {
    return String(error.stack)
  } else {
    return null
  }
}

function getMessage (error: unknown) {
  if (typeof error === 'object' && error instanceof Error) {
    return error.message
  } else if (typeof error === 'string') {
    return error
  } else {
    return String(error)
  }
}

export function trackError (event: ErrorEvent) {
  Timeline.trackError({
    source: 'event',
    message: event.message,
    stack: getStack(event.error)
  })
}

export function trackPromiseRejected (event: PromiseRejectionEvent) {
  Timeline.trackError({
    source: 'promise',
    message: String(event.reason),
    stack: getStack(event)
  })
}

export function trackVueError (error: unknown, _instance: ComponentPublicInstance | null, info: string) {
  Timeline.trackError({
    source: 'vue',
    message: getMessage(error) || info,
    stack: getStack(error)
  })
}